module.exports = __webpack_public_path__ + "static/media/FreedomEdge-30ml.3f097c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FreedomEdge-30ml.png
// module id = 249
// module chunks = 0